















































































































































































































































import { Vue, Component, Watch } from 'vue-property-decorator';
import SpinnerOverlay from '@/project/spinners/SpinnerOverlay.vue';
import dictionaryService from '@/core/translation/dictionary.service';
import bus from '@/core/bus';
import { ClientMessageType, ClientMessageWithError, GeneralErrorEventKey } from '@/core/messages/types';
import { TranslationLink } from '@/core/translation/translation-with-links.vue';
import contentPageOverlayService from '@/project/modals/overlays/ContentPageOverlay.service';
import serverContextService from '@/core/serverContext.service';
import { validationRuleAddressField } from '@/project/form/vee-validate.plugin';

@Component({
    components: { SpinnerOverlay }
})
export default class KitchenSink extends Vue {
    private model = {
        companyName: '',
        streetAndNumber: '',
        postalCode: '',
        town: '',
        country: '',
        contactPerson: '',
        email: '',
        termsAccepted: false,
        radioGroup: null,
        selectedCountryOption: null
    };

    radioOptions = [
        { value: 'orange', displayName: 'Orange' },
        { value: 'beer', displayName: 'Beers' },
        { value: 'hd', displayName: 'Hard drives' },
        { value: -1, displayName: 'Floppy Discs' },
        { value: true, displayName: 'true' }
    ];

    countryOptions = [{
        countryLabel: 'Please select',
        countryCode: null,
        id: -1
    }, {
        countryLabel: 'England',
        countryCode: 'en-gb',
        id: 1
    }, {
        countryLabel: 'Danmark',
        countryCode: 'da-dk',
        id: 2
    }, {
        countryLabel: 'Øst Danmark',
        countryCode: 'da-bornholmsk',
        id: 3
    }, {
        countryLabel: 'Vest Danmark',
        countryCode: 'da-vestjysk',
        id: 4
    }];

    private file:FileList | null = null;
    private allIcons: string[] = [];
    private iconsIsOriginal: boolean = true;
    private iconsColor: boolean = false;
    private iconsFill: boolean = true;
    private iconsSize: number = 30;
    private iconsSizeOptions: number[] = [30, 50, 100];

    get fakeBlocksData() {
        return [
            {
                name: null,
                alias: 'halfWidthBlocks',
                content: {
                    blocks: [
                        {
                            name: null,
                            alias: 'halfWidthBlock',
                            content: {
                                video: null,
                                vimeoVideoId: '',
                                captionLocation: null,
                                anchorLink: '',
                                isBackgroundVideo: true,
                                showVideoControls: false,
                                backgroundColor: '',
                                backgroundImageBehavior: 'cover', // cover, alignTop, center
                                backgroundImage: {
                                    focalPoint: {
                                        left: 0.5,
                                        top: 0.5
                                    },
                                    width: 1440,
                                    height: 480,
                                    extension: 'jpg',
                                    name: 'Vertiv Brandpage Image',
                                    url: 'http://localhost:4080/media/qxjn0kg3/vertiv-brandpage-image.jpg',
                                    target: ''
                                },
                                shimColor: '',
                                caption: '',
                                captionColor: '',
                                header: '',
                                headerColor: '',
                                subheader: 'fff',
                                subheaderColor: 'ff0000',
                                callToAction: null,
                                callToActionColor: '',
                                contentBackgroundColor: 'ffffff',
                                makeContentBackgroundTransparent: true
                            }
                        },
                        {
                            name: null,
                            alias: 'uniqueSellingPointBlock',
                            content: {
                                uniqueSellingPointItems: [
                                    {
                                        name: null,
                                        alias: 'uniqueSellingPointItem',
                                        content: {
                                            iconBackgroundColor: '#',
                                            headline: 'Secure data sanitisation',
                                            icon: {
                                                focalPoint: {
                                                    left: 0.5,
                                                    top: 0.5
                                                },
                                                width: 2084,
                                                height: 2084,
                                                extension: 'png',
                                                name: 'Solutions Icon Black',
                                                url: 'http://localhost:4080/media/5drdsu23/solutions_icon_black.png',
                                                target: ''
                                            },
                                            link: {
                                                name: 'EET Danmark',
                                                target: null,
                                                url: '/da-dk',
                                                type: 0
                                            },
                                            shortText: 'EET ITAD services uses industry-leading software, which is fully compliant with Government standards, guaranteeing 100% data erasure',
                                            anchorLink: ''
                                        }
                                    },
                                    {
                                        name: null,
                                        alias: 'uniqueSellingPointItem',
                                        content: {
                                            iconBackgroundColor: '#00ff00',
                                            headline: 'The sustainable option',
                                            icon: {
                                                focalPoint: {
                                                    left: 0.5,
                                                    top: 0.5
                                                },
                                                width: 2084,
                                                height: 2084,
                                                extension: 'png',
                                                name: 'Solutions Icon Black',
                                                url: 'http://localhost:4080/media/5drdsu23/solutions_icon_black.png',
                                                target: ''
                                            },
                                            link: {
                                                name: 'EET Danmark',
                                                target: null,
                                                url: '/da-dk',
                                                type: 0
                                            },
                                            shortText: 'EET ITAD service is an R2 certified, zero to landfill business that refurbishes over 99% of the IT equipment it receives. The remaining devices are ethically recycled.',
                                            anchorLink: ''
                                        }
                                    },
                                    {
                                        name: null,
                                        alias: 'uniqueSellingPointItem',
                                        content: {
                                            iconBackgroundColor: '',
                                            headline: '',
                                            icon: {
                                                focalPoint: {
                                                    left: 0.5,
                                                    top: 0.5
                                                },
                                                width: 2084,
                                                height: 2084,
                                                extension: 'png',
                                                name: 'Rack Icon Black',
                                                url: 'http://localhost:4080/media/ik2cen1s/rack_icon_black.png',
                                                target: ''
                                            },
                                            link: {
                                                name: 'EET Danmark',
                                                target: null,
                                                url: '/da-dk',
                                                type: 0
                                            },
                                            shortText: 'We provide full end-of-life and data sanitisation documentation for complete peace of mind.',
                                            anchorLink: ''
                                        }
                                    },
                                    {
                                        name: null,
                                        alias: 'uniqueSellingPointItem',
                                        content: {
                                            iconBackgroundColor: 'ff00ff',
                                            headline: 'Secure colletion and transpotation',
                                            icon: {
                                                focalPoint: {
                                                    left: 0.5,
                                                    top: 0.5
                                                },
                                                width: 2084,
                                                height: 2084,
                                                extension: 'png',
                                                name: 'It And Edge Infrastructure Icon Black',
                                                url: 'http://localhost:4080/media/uhqhwcot/it-and-edge-infrastructure_icon_black.png',
                                                target: ''
                                            },
                                            link: {
                                                name: 'EET Danmark',
                                                target: null,
                                                url: '/da-dk',
                                                type: 0
                                            },
                                            shortText: '',
                                            anchorLink: ''
                                        }
                                    }
                                ],
                                appendToPreviousBlock: false,
                                backgroundColor: 'b3b312',
                                customBackgroundColor: null,
                                anchorLink: '',
                                headline: 'Headline'
                            }
                        }
                    ],
                    appendToPreviousBlock: false,
                    anchorLink: ''
                }
            },

            {
                name: null,
                alias: 'halfWidthBlocks',
                content: {
                    blocks: [
                        {
                            name: null,
                            alias: 'halfWidthBlock',
                            content: {
                                video: null,
                                vimeoVideoId: '',
                                captionLocation: null,
                                anchorLink: '',
                                isBackgroundVideo: true,
                                showVideoControls: false,
                                backgroundColor: '#fe5a1b',
                                backgroundImage: {
                                    focalPoint: {
                                        left: 0.5,
                                        top: 0.5
                                    },
                                    width: 710,
                                    height: 474,
                                    extension: 'jpg',
                                    name: 'Edge UPS',
                                    url: 'http://localhost:4080/media/jcfdwvug/edge-ups.jpg',
                                    target: ''
                                },
                                backgroundImageBehavior: 'cover', // cover, alignTop, center
                                shimColor: '',
                                caption: '',
                                captionColor: '',
                                header: '',
                                headerColor: '',
                                subheader: '',
                                subheaderColor: '',
                                callToAction: null,
                                callToActionColor: '',
                                contentBackgroundColor: '',
                                makeContentBackgroundTransparent: true
                            }
                        },
                        {
                            name: null,
                            alias: 'textBlock',
                            content: {
                                backgroundColor: 'ffffff',
                                customBackgroundColor: null,
                                bodyText: '<p>Why not choose the most enhanced power protection for your customers’ IT Edge applications whilst saving energy? With the new line-interactive <strong>Vertiv™ Edge</strong> UPS there is no trade-off!</p>\n<p>Available as rack-mountable or monolithic, this highly efficient and compact unit has the super-powers to protect your customers’ IT loads and their budget.</p>\n<ul>\n<li><strong>High Output Power Factor (0.9)</strong></li>\n<li><strong>Efficiency up to 98%</strong></li>\n<li><strong>Controllable Outlets</strong></li>\n<li><strong>Multiple form factors to choose from</strong></li>\n</ul>\n<p><a rel="noopener" href="https://www.vertiv.com/en-emea/campaigns/vertiv-edge-ups/" target="_blank">FIND OUT MORE</a></p>\n<p><a href="https://www.vertiv.com/4a7847/globalassets/products/critical-power/uninterruptible-power-supplies-ups/vertiv-edge-ups-brochure---emea.pdf">VIEW BROCHURE</a></p>',
                                headline: 'Vertiv™ Edge UPS cover',
                                callToAction: null,
                                anchorLink: '',
                                callToActionColor: ''
                            }
                        }
                    ],
                    appendToPreviousBlock: false,
                    anchorLink: ''
                }
            },
            {
                name: null,
                alias: 'halfWidthBlocks',
                content: {
                    blocks: [
                        {
                            name: null,
                            alias: 'halfWidthBlock',
                            content: {
                                video: null,
                                vimeoVideoId: '',
                                captionLocation: null,
                                anchorLink: '',
                                isBackgroundVideo: true,
                                showVideoControls: false,
                                backgroundColor: '#fe5a1b',
                                backgroundImage: {
                                    focalPoint: {
                                        left: 0.5,
                                        top: 0.5
                                    },
                                    width: 710,
                                    height: 474,
                                    extension: 'jpg',
                                    name: 'Edge UPS',
                                    url: 'http://localhost:4080/media/jcfdwvug/edge-ups.jpg',
                                    target: ''
                                },
                                backgroundImageBehavior: 'alignTop', // cover, alignTop, center
                                shimColor: '',
                                caption: '',
                                captionColor: '',
                                header: '',
                                headerColor: '',
                                subheader: '',
                                subheaderColor: '',
                                callToAction: null,
                                callToActionColor: '',
                                contentBackgroundColor: '',
                                makeContentBackgroundTransparent: true
                            }
                        },
                        {
                            name: null,
                            alias: 'textBlock',
                            content: {
                                backgroundColor: 'ffffff',
                                customBackgroundColor: null,
                                bodyText: '<p>Why not choose the most enhanced power protection for your customers’ IT Edge applications whilst saving energy? With the new line-interactive <strong>Vertiv™ Edge</strong> UPS there is no trade-off!</p>\n<p>Available as rack-mountable or monolithic, this highly efficient and compact unit has the super-powers to protect your customers’ IT loads and their budget.</p>\n<ul>\n<li><strong>High Output Power Factor (0.9)</strong></li>\n<li><strong>Efficiency up to 98%</strong></li>\n<li><strong>Controllable Outlets</strong></li>\n<li><strong>Multiple form factors to choose from</strong></li>\n</ul>\n<p><a rel="noopener" href="https://www.vertiv.com/en-emea/campaigns/vertiv-edge-ups/" target="_blank">FIND OUT MORE</a></p>\n<p><a href="https://www.vertiv.com/4a7847/globalassets/products/critical-power/uninterruptible-power-supplies-ups/vertiv-edge-ups-brochure---emea.pdf">VIEW BROCHURE</a></p>',
                                headline: 'Vertiv™ Edge UPS alignTop',
                                callToAction: null,
                                anchorLink: '',
                                callToActionColor: ''
                            }
                        }
                    ],
                    appendToPreviousBlock: false,
                    anchorLink: ''
                }
            },
            {
                name: null,
                alias: 'halfWidthBlocks',
                content: {
                    blocks: [
                        {
                            name: null,
                            alias: 'halfWidthBlock',
                            content: {
                                video: null,
                                vimeoVideoId: '',
                                captionLocation: null,
                                anchorLink: '',
                                isBackgroundVideo: true,
                                showVideoControls: false,
                                backgroundColor: '#fe5a1b',
                                backgroundImage: {
                                    focalPoint: {
                                        left: 0.5,
                                        top: 0.5
                                    },
                                    width: 710,
                                    height: 474,
                                    extension: 'jpg',
                                    name: 'Edge UPS',
                                    url: 'http://localhost:4080/media/jcfdwvug/edge-ups.jpg',
                                    target: ''
                                },
                                backgroundImageBehavior: 'center', // cover, alignTop, center
                                shimColor: '',
                                caption: '',
                                captionColor: '',
                                header: '',
                                headerColor: '',
                                subheader: '',
                                subheaderColor: '',
                                callToAction: null,
                                callToActionColor: '',
                                contentBackgroundColor: '',
                                makeContentBackgroundTransparent: true
                            }
                        },
                        {
                            name: null,
                            alias: 'textBlock',
                            content: {
                                backgroundColor: 'ffffff',
                                customBackgroundColor: null,
                                bodyText: '<p>Why not choose the most enhanced power protection for your customers’ IT Edge applications whilst saving energy? With the new line-interactive <strong>Vertiv™ Edge</strong> UPS there is no trade-off!</p>\n<p>Available as rack-mountable or monolithic, this highly efficient and compact unit has the super-powers to protect your customers’ IT loads and their budget.</p>\n<ul>\n<li><strong>High Output Power Factor (0.9)</strong></li>\n<li><strong>Efficiency up to 98%</strong></li>\n<li><strong>Controllable Outlets</strong></li>\n<li><strong>Multiple form factors to choose from</strong></li>\n</ul>\n<p><a rel="noopener" href="https://www.vertiv.com/en-emea/campaigns/vertiv-edge-ups/" target="_blank">FIND OUT MORE</a></p>\n<p><a href="https://www.vertiv.com/4a7847/globalassets/products/critical-power/uninterruptible-power-supplies-ups/vertiv-edge-ups-brochure---emea.pdf">VIEW BROCHURE</a></p>',
                                headline: 'Vertiv™ Edge UPS center',
                                callToAction: null,
                                anchorLink: '',
                                callToActionColor: ''
                            }
                        }
                    ],
                    appendToPreviousBlock: false,
                    anchorLink: ''
                }
            },
            {
                name: null,
                alias: 'halfWidthBlocks',
                content: {
                    blocks: [
                        {
                            name: null,
                            alias: 'halfWidthBlock',
                            content: {
                                video: null,
                                vimeoVideoId: '',
                                captionLocation: null,
                                anchorLink: '',
                                isBackgroundVideo: true,
                                showVideoControls: false,
                                backgroundColor: '#fe5a1b',
                                backgroundImage: {
                                    focalPoint: {
                                        left: 0.5,
                                        top: 0.5
                                    },
                                    width: 710,
                                    height: 474,
                                    extension: 'jpg',
                                    name: 'Edge UPS',
                                    url: 'http://localhost:4080/media/jcfdwvug/edge-ups.jpg',
                                    target: ''
                                },
                                backgroundImageBehavior: 'center', // cover, alignTop, center
                                shimColor: '',
                                caption: '',
                                captionColor: '',
                                header: '',
                                headerColor: '',
                                subheader: '',
                                subheaderColor: '',
                                callToAction: null,
                                callToActionColor: '',
                                contentBackgroundColor: '',
                                makeContentBackgroundTransparent: true
                            }
                        },
                        {
                            name: null,
                            alias: 'textBlock',
                            content: {
                                backgroundColor: 'ffffff',
                                customBackgroundColor: null,
                                bodyText: '<p>Long text why not choose the most enhanced power protection for your customers’ IT Edge applications whilst saving energy? With the new line-interactive <strong>Vertiv™ Edge</strong> UPS there is no trade-off!</p>\n<p>Available as rack-mountable or monolithic, this highly efficient and compact unit has the super-powers to protect your customers’ IT loads and their budget.</p>\n\n<p>Available as rack-mountable or monolithic, this highly efficient and compact unit has the super-powers to protect your customers’ IT loads and their budget.</p>\n\n<p>Available as rack-mountable or monolithic, this highly efficient and compact unit has the super-powers to protect your customers’ IT loads and their budget.</p>\n\n<p>Available as rack-mountable or monolithic, this highly efficient and compact unit has the super-powers to protect your customers’ IT loads and their budget.</p>\n\n<p>Available as rack-mountable or monolithic, this highly efficient and compact unit has the super-powers to protect your customers’ IT loads and their budget.</p>\n<ul>\n<li><strong>High Output Power Factor (0.9)</strong></li>\n<li><strong>Efficiency up to 98%</strong></li>\n<li><strong>Controllable Outlets</strong></li>\n<li><strong>Multiple form factors to choose from</strong></li>\n</ul>\n<p><a rel="noopener" href="https://www.vertiv.com/en-emea/campaigns/vertiv-edge-ups/" target="_blank">FIND OUT MORE</a></p>\n<p><a href="https://www.vertiv.com/4a7847/globalassets/products/critical-power/uninterruptible-power-supplies-ups/vertiv-edge-ups-brochure---emea.pdf">VIEW BROCHURE</a></p>',
                                headline: 'Vertiv™ Edge UPS center',
                                callToAction: null,
                                anchorLink: '',
                                callToActionColor: ''
                            }
                        }
                    ],
                    appendToPreviousBlock: false,
                    anchorLink: ''
                }
            },
            {
                name: null,
                alias: 'halfWidthBlocks',
                content: {
                    blocks: [
                        {
                            name: null,
                            alias: 'halfWidthBlock',
                            content: {
                                video: null,
                                vimeoVideoId: '',
                                captionLocation: null,
                                anchorLink: '',
                                isBackgroundVideo: true,
                                showVideoControls: false,
                                backgroundColor: '#fe5a1b',
                                backgroundImage: {
                                    focalPoint: {
                                        left: 0.5,
                                        top: 0.5
                                    },
                                    width: 710,
                                    height: 474,
                                    extension: 'jpg',
                                    name: 'Edge UPS',
                                    url: 'http://localhost:4080/media/jcfdwvug/edge-ups.jpg',
                                    target: ''
                                },
                                backgroundImageBehavior: 'center', // cover, alignTop, center
                                shimColor: '',
                                caption: '',
                                captionColor: '',
                                header: '',
                                headerColor: '',
                                subheader: '',
                                subheaderColor: '',
                                callToAction: null,
                                callToActionColor: '',
                                contentBackgroundColor: '',
                                makeContentBackgroundTransparent: true
                            }
                        },
                        {
                            name: null,
                            alias: 'textBlock',
                            content: {
                                backgroundColor: 'ffffff',
                                customBackgroundColor: null,
                                bodyText: '<p>Short text why not choose the most enhanced power protection for your customers’ IT Edge applications whilst saving energy? With the new line-interactive <strong>Vertiv™ Edge</strong> UPS there is no trade-off!</p>\n<p><a rel="noopener" href="https://www.vertiv.com/en-emea/campaigns/vertiv-edge-ups/" target="_blank">FIND OUT MORE</a></p>\n<p><a href="https://www.vertiv.com/4a7847/globalassets/products/critical-power/uninterruptible-power-supplies-ups/vertiv-edge-ups-brochure---emea.pdf">VIEW BROCHURE</a></p>',
                                headline: 'Vertiv™ Edge UPS center',
                                callToAction: null,
                                anchorLink: '',
                                callToActionColor: ''
                            }
                        }
                    ],
                    appendToPreviousBlock: false,
                    anchorLink: ''
                }
            },
            {
                name: null,
                alias: 'halfWidthBlocks',
                content: {
                    blocks: [
                        {
                            name: null,
                            alias: 'halfWidthBlock',
                            content: {
                                video: null,
                                vimeoVideoId: '',
                                captionLocation: null,
                                anchorLink: '',
                                isBackgroundVideo: true,
                                showVideoControls: false,
                                backgroundColor: '',
                                backgroundImage: {
                                    focalPoint: {
                                        left: 0.5,
                                        top: 0.5
                                    },
                                    width: 1440,
                                    height: 480,
                                    extension: 'jpg',
                                    name: 'Vertiv Brandpage Image',
                                    url: 'http://localhost:4080/media/qxjn0kg3/vertiv-brandpage-image.jpg',
                                    target: ''
                                },
                                shimColor: '',
                                caption: '',
                                captionColor: '',
                                header: '',
                                headerColor: '',
                                subheader: '',
                                subheaderColor: '',
                                callToAction: null,
                                callToActionColor: '',
                                contentBackgroundColor: '',
                                makeContentBackgroundTransparent: true
                            }
                        },
                        {
                            name: null,
                            alias: 'textBlock',
                            content: {
                                backgroundColor: 'ffffff',
                                customBackgroundColor: null,
                                bodyText: '<p>Why not choose the most enhanced power protection for your customers’ IT Edge applications whilst saving energy? With the new line-interactive <strong>Vertiv™ Edge</strong> UPS there is no trade-off!</p>\n<p>Available as rack-mountable or monolithic, this highly efficient and compact unit has the super-powers to protect your customers’ IT loads and their budget.</p>\n<ul>\n<li><strong>High Output Power Factor (0.9)</strong></li>\n<li><strong>Efficiency up to 98%</strong></li>\n<li><strong>Controllable Outlets</strong></li>\n<li><strong>Multiple form factors to choose from</strong></li>\n</ul>\n<p><a rel="noopener" href="https://www.vertiv.com/en-emea/campaigns/vertiv-edge-ups/" target="_blank">FIND OUT MORE</a></p>\n<p><a href="https://www.vertiv.com/4a7847/globalassets/products/critical-power/uninterruptible-power-supplies-ups/vertiv-edge-ups-brochure---emea.pdf">VIEW BROCHURE</a></p>',
                                headline: 'Vertiv™ Mastercard Default',
                                callToAction: null,
                                anchorLink: '',
                                callToActionColor: ''
                            }
                        }
                    ],
                    appendToPreviousBlock: false,
                    anchorLink: ''
                }
            },
            {
                name: null,
                alias: 'halfWidthBlocks',
                content: {
                    blocks: [
                        {
                            name: null,
                            alias: 'halfWidthBlock',
                            content: {
                                video: null,
                                vimeoVideoId: '',
                                captionLocation: null,
                                anchorLink: '',
                                isBackgroundVideo: true,
                                showVideoControls: false,
                                backgroundColor: '',
                                backgroundImageBehavior: 'center', // cover, alignTop, center
                                backgroundImage: {
                                    focalPoint: {
                                        left: 0.5,
                                        top: 0.5
                                    },
                                    width: 1440,
                                    height: 480,
                                    extension: 'jpg',
                                    name: 'Vertiv Brandpage Image',
                                    url: 'http://localhost:4080/media/qxjn0kg3/vertiv-brandpage-image.jpg',
                                    target: ''
                                },
                                shimColor: '',
                                caption: '',
                                captionColor: '',
                                header: '',
                                headerColor: '',
                                subheader: '',
                                subheaderColor: '',
                                callToAction: null,
                                callToActionColor: '',
                                contentBackgroundColor: '',
                                makeContentBackgroundTransparent: true
                            }
                        },
                        {
                            name: null,
                            alias: 'textBlock',
                            content: {
                                backgroundColor: 'ffffff',
                                customBackgroundColor: null,
                                bodyText: '<p>Why not choose the most enhanced power protection for your customers’ IT Edge applications whilst saving energy? With the new line-interactive <strong>Vertiv™ Edge</strong> UPS there is no trade-off!</p>\n<p>Available as rack-mountable or monolithic, this highly efficient and compact unit has the super-powers to protect your customers’ IT loads and their budget.</p>\n<ul>\n<li><strong>High Output Power Factor (0.9)</strong></li>\n<li><strong>Efficiency up to 98%</strong></li>\n<li><strong>Controllable Outlets</strong></li>\n<li><strong>Multiple form factors to choose from</strong></li>\n</ul>\n<p><a rel="noopener" href="https://www.vertiv.com/en-emea/campaigns/vertiv-edge-ups/" target="_blank">FIND OUT MORE</a></p>\n<p><a href="https://www.vertiv.com/4a7847/globalassets/products/critical-power/uninterruptible-power-supplies-ups/vertiv-edge-ups-brochure---emea.pdf">VIEW BROCHURE</a></p>',
                                headline: 'Vertiv™ Edge UPS Mastercard Behave',
                                callToAction: null,
                                anchorLink: '',
                                callToActionColor: ''
                            }
                        }
                    ],
                    appendToPreviousBlock: false,
                    anchorLink: ''
                }
            },
            {
                name: null,
                alias: 'halfWidthBlocks',
                content: {
                    blocks: [
                        {
                            name: null,
                            alias: 'halfWidthBlock',
                            content: {
                                video: null,
                                vimeoVideoId: '518955703',
                                captionLocation: null,
                                anchorLink: '',
                                isBackgroundVideo: true,
                                showVideoControls: false,
                                backgroundColor: '#122245',
                                backgroundImage: null,
                                shimColor: '',
                                caption: '',
                                captionColor: '',
                                header: '',
                                headerColor: '',
                                subheader: '',
                                subheaderColor: '',
                                callToAction: null,
                                callToActionColor: '',
                                contentBackgroundColor: '',
                                makeContentBackgroundTransparent: true
                            }
                        },
                        {
                            name: null,
                            alias: 'textBlock',
                            content: {
                                backgroundColor: 'ffffff',
                                customBackgroundColor: null,
                                bodyText: '<p>Vertiv™ provides a comprehensive portfolio of power supply, cooling and IT infrastructure and services. With Vertiv\'s solutions, you can ensure your customers\' mission-critical applications run uninterrupted, deliver the best performance and grow in line with their needs.</p>',
                                headline: 'An Introduction to Vertiv',
                                callToAction: null,
                                anchorLink: '',
                                callToActionColor: ''
                            }
                        }
                    ],
                    appendToPreviousBlock: false,
                    anchorLink: ''
                }
            },
            {
                name: null,
                alias: 'heroBanner',
                content: {
                    subheaderFontSizeValue: 1,
                    appendToPreviousBlock: false,
                    contentWidthValue: 1,
                    contentAligmentValue: 0,
                    video: null,
                    vimeoVideoId: '',
                    captionLocation: null,
                    anchorLink: '',
                    isBackgroundVideo: true,
                    showVideoControls: false,
                    backgroundColor: '',
                    backgroundImage: {
                        focalPoint: {
                            left: 0.5,
                            top: 0.5
                        },
                        width: 1140,
                        height: 480,
                        extension: 'jpg',
                        name: 'Header Banner1',
                        url: 'http://localhost:4080/media/vrzhaygw/header-banner1.jpg',
                        target: ''
                    },
                    shimColor: '',
                    caption: '',
                    captionColor: '',
                    header: '',
                    headerColor: '',
                    subheader: '',
                    subheaderColor: '',
                    callToAction: null,
                    callToActionColor: '',
                    contentBackgroundColor: '',
                    makeContentBackgroundTransparent: true
                }
            },
            {
                name: null,
                alias: 'heroBanner',
                content: {
                    subheaderFontSizeValue: 1,
                    appendToPreviousBlock: false,
                    contentWidthValue: 1,
                    contentAligmentValue: 0,
                    video: null,
                    vimeoVideoId: '',
                    captionLocation: null,
                    anchorLink: '',
                    isBackgroundVideo: true,
                    showVideoControls: false,
                    backgroundColor: '',
                    backgroundImage: {
                        focalPoint: {
                            left: 0.5,
                            top: 0.5
                        },
                        width: 1140,
                        height: 480,
                        extension: 'jpg',
                        name: 'Header Banner1',
                        url: 'http://localhost:4080/media/vrzhaygw/header-banner1.jpg',
                        target: ''
                    },
                    shimColor: '',
                    caption: '',
                    captionColor: '',
                    header: 'Hello Heros',
                    headerColor: '',
                    subheader: 'This is just a normal hero banner with text',
                    subheaderColor: '',
                    callToAction: null,
                    callToActionColor: '',
                    contentBackgroundColor: '#ffffff',
                    makeContentBackgroundTransparent: true
                }
            },

            {
                name: null,
                alias: 'halfWidthBlocks',
                content: {
                    blocks: [
                        {
                            name: null,
                            alias: 'halfWidthBlock',
                            content: {
                                backgroundColor: '',
                                marginColor: null,
                                backgroundImageBehavior: 'center', // cover, alignTop, center
                                backgroundImage: {
                                    focalPoint: {
                                        left: 0.5,
                                        top: 0.5
                                    },
                                    width: 1440,
                                    height: 480,
                                    extension: 'jpg',
                                    name: 'Vertiv Brandpage Image',
                                    url: 'https://assets.eetgroup.com/gEfvQfDN93Mb5ijuwev_w7s0VCjDTLy1BbjoywsACdg.jpg',
                                    target: ''
                                },
                                backgroundImages: [
                                    {
                                        url: 'https://assets.eetgroup.com/ow87vJrE0yDqyS9OzugPui3-joCcWb7Le5Tj1zAuOyg.jpg',
                                        width: 1440,
                                        height: 480
                                    },
                                    {
                                        url: 'https://assets.eetgroup.com/gEfvQfDN93Mb5ijuwev_w7s0VCjDTLy1BbjoywsACdg.jpg',
                                        width: 710,
                                        height: 474
                                    }
                                ],
                                imageLeft: null,
                                imageRight: null,
                                shim: false,
                                shimColor: '',
                                header: 'Remote controllers',
                                headerColor: '#ffffff',
                                subheader: 'Replace your broken or lost remote with universal remote controllers for Samsung and Sony TVs',
                                subheaderColor: '#ffffff',
                                caption: 'CoreParts',
                                captionColor: '#ffffff',
                                menuColor: null,
                                topColor: null,
                                subheaderFontSizeValue: 0,
                                callToAction: {
                                    name: 'Order here',
                                    target: '',
                                    url: '/consumer-electronics/sound-vision/tv-accessories/remote-controls/c-25725763?ATTR_Brandname=CoreParts&lastFacet=ATTR_Brandname'
                                },
                                callToActionColor: '#ffffff',
                                contentBackgroundColor: '#27aae1',
                                makeContentBackgroundTransparent: false,
                                takeoverTheme: null,
                                contentWidthValue: 1,
                                contentAligmentValue: 0,
                                vimeoVideoId: '',
                                overlayVimeoVideoId: '',
                                overlayVimeoCta: null
                            }
                        },
                        {
                            name: null,
                            alias: 'halfWidthBlock',
                            content: {
                                backgroundColor: '',
                                marginColor: null,
                                backgroundImageBehavior: 'center', // cover, alignTop, center
                                backgroundImage: {
                                    focalPoint: {
                                        left: 0.5,
                                        top: 0.5
                                    },
                                    width: 710,
                                    height: 474,
                                    extension: 'jpg',
                                    name: 'Vertiv Brandpage Image',
                                    url: 'https://assets.eetgroup.com/7U_KE0JQt-JQYtEwY0zOYhoTr6aFV8rhyaHNVnUawM4.jpg',
                                    target: ''
                                },
                                backgroundImages: [
                                    {
                                        url: 'https://assets.eetgroup.com/lOQ8dS1zJ0ab4kTWqU0cYGy_MfegSJ0xk1HhMc3SP98.jpg',
                                        width: 1440,
                                        height: 480
                                    },
                                    {
                                        url: 'https://assets.eetgroup.com/7U_KE0JQt-JQYtEwY0zOYhoTr6aFV8rhyaHNVnUawM4.jpg',
                                        width: 710,
                                        height: 474
                                    }
                                ],
                                imageLeft: null,
                                imageRight: null,
                                shim: false,
                                shimColor: '',
                                header: 'Solar charging',
                                headerColor: '#ffffff',
                                subheader: 'Enjoy the great outdoors and charge your devices anywhere, at anytime with solar powerbanks and solar chargers.',
                                subheaderColor: '#ffffff',
                                caption: 'SANDBERG',
                                captionColor: '#ffffff',
                                menuColor: null,
                                topColor: null,
                                subheaderFontSizeValue: 1,
                                callToAction: {
                                    name: 'Order here',
                                    target: '',
                                    url: '/campaigns/sandberg_solar_products'
                                },
                                callToActionColor: '#ffffff',
                                contentBackgroundColor: '#3EBAEB',
                                makeContentBackgroundTransparent: true,
                                takeoverTheme: null,
                                contentWidthValue: 1,
                                contentAligmentValue: 0,
                                vimeoVideoId: '',
                                overlayVimeoVideoId: '',
                                overlayVimeoCta: null
                            }
                        },
                        {
                            name: null,
                            alias: 'halfWidthBlock',
                            content: {
                                backgroundColor: '',
                                marginColor: null,
                                backgroundImageBehavior: 'center', // cover, alignTop, center
                                backgroundImage: {
                                    focalPoint: {
                                        left: 0.5,
                                        top: 0.5
                                    },
                                    width: 710,
                                    height: 474,
                                    extension: 'jpg',
                                    name: 'Vertiv Brandpage Image',
                                    url: 'https://assets.eetgroup.com/7mxTqviCrIh0uOpnAaVXB36y1qfCa2dF0GTe_wFKf8Y.jpg',
                                    target: ''
                                },
                                backgroundImages: [
                                    {
                                        url: 'https://assets.eetgroup.com/O5hkEcXaIONDDHeWVq_7Zia-M-jhFqnY33hIpsq48js.jpg',
                                        width: 1440,
                                        height: 480
                                    },
                                    {
                                        url: 'https://assets.eetgroup.com/7mxTqviCrIh0uOpnAaVXB36y1qfCa2dF0GTe_wFKf8Y.jpg',
                                        width: 710,
                                        height: 474
                                    }
                                ],
                                imageLeft: null,
                                imageRight: null,
                                shim: false,
                                shimColor: '',
                                header: 'New iPhone out now',
                                headerColor: '#ffffff',
                                subheader: 'Stock up on accessories for the NEW iPhone 14 series',
                                subheaderColor: '#ffffff',
                                caption: 'eSTUFF',
                                captionColor: '#ffffff',
                                menuColor: null,
                                topColor: null,
                                subheaderFontSizeValue: 1,
                                callToAction: {
                                    name: 'Order here',
                                    target: '',
                                    url: '/campaigns/iphone_14_assortment'
                                },
                                callToActionColor: '#ffffff',
                                contentBackgroundColor: '#00a19b',
                                makeContentBackgroundTransparent: true,
                                takeoverTheme: null,
                                contentWidthValue: 1,
                                contentAligmentValue: 0,
                                lineItemId: 'dct695smy0qst5zm',
                                creativeId: 'grckvcw5hbzxb1m5',
                                adUnitId: '00000000000cda57',
                                layoutId: 'ydylnrst8k9kd0dc',
                                vimeoVideoId: '',
                                overlayVimeoVideoId: '',
                                overlayVimeoCta: null
                            }
                        }
                    ],
                    appendToPreviousBlock: false,
                    anchorLink: ''
                }
            }

            // {
            //     renderedPixelUrl: 'https://delivery.adnuntius.com/b/WtCz5QfTwiqp03AaYthngM3crgLHLHcaB9fnbmSIHFYAAAAQCtjQz9kbGWD4nuZy3q6HaHGLBt-sr6vGV0PUa7iKL4r1_xgFOAP_DJ7fwK27FHlLzlH9fQ9OqBy180z0xTRb-MLw2QxPbI-9rowhcJRlgAQA6VQYqZFbIWIVTdljEDl0WM8WU48WqRVnuLSXXbWUvL6bTEI_Vg6PMRfCUEt7kPaf90oHC-GEMrR4VfZucZGeTn0jpW3LZeS3zo0Z3fB1YFZG_dxe-OB-HMA3X8zadeGi7RORs7GsqXYCdNQyDbA3L4Tg97DTDaHphyeX6iaCoK6KyW22WD4KAw.html',
            //     visiblePixelUrl: 'https://delivery.adnuntius.com/s?rt=WtCz5QfTwiqp03AaYthngM3crgLHLHcaB9fnbmSIHFYAAAAQCtjQz9kbGWD4nuZy3q6HaHGLBt-sr6vGV0PUa7iKL4r1_xgFOAP_DJ7fwK27FHlLzlH9fQ9OqBy180z0xTRb-MLw2QxPbI-9rowhcJRlgAQA6VQYqZFbIWIVTdljEDl0WM8WU48WqRVnuLSXXbWUvL6bTEI_Vg6PMRfCUEt7kPaf90oHC-GEMrR4VfZucZGeTn0jpW3LZeS3zo0Z3fB1YFZG_dxe-OB-HMA3X8zadeGi7RORs7GsqXYCdNQyDbA3L4Tg97DTDaHphyeX6iaCoK6KyW22WD4KAw',
            //     viewPixelUrl: 'https://delivery.adnuntius.com/v?rt=WtCz5QfTwiqp03AaYthngM3crgLHLHcaB9fnbmSIHFYAAAAQCtjQz9kbGWD4nuZy3q6HaHGLBt-sr6vGV0PUa7iKL4r1_xgFOAP_DJ7fwK27FHlLzlH9fQ9OqBy180z0xTRb-MLw2QxPbI-9rowhcJRlgAQA6VQYqZFbIWIVTdljEDl0WM8WU48WqRVnuLSXXbWUvL6bTEI_Vg6PMRfCUEt7kPaf90oHC-GEMrR4VfZucZGeTn0jpW3LZeS3zo0Z3fB1YFZG_dxe-OB-HMA3X8zadeGi7RORs7GsqXYCdNQyDbA3L4Tg97DTDaHphyeX6iaCoK6KyW22WD4KAw',
            //     clickPixelUrl: 'https://delivery.adnuntius.com/c/WtCz5QfTwiqp03AaYthngM3crgLHLHcaB9fnbmSIHFYAAAAQCtjQz9kbGWD4nuZy3q6HaHGLBt-sr6vGV0PUa7iKL4r1_xgFOAP_DJ7fwK27FHlLzlH9fQ9OqBy180z0xTRb-MLw2QxPbI-9rowhcJRlgAQA6VQYqZFbIWIVTdljEDl0WM8WU48WqRVnuLSXXbWUvL6bTEI_Vg6PMRfCUEt7kPaf90oHC-GEMrR4VfZucZGeTn0jpW3LZeS3zo0Z3fB1YFZG_dxe-OB-HMA3X8zadeGi7RORs7GsqXYCdNQyDbA3L4Tg97DTDaHphyeX6iaCoK6KyW22WD4KAw',
            //     backgroundColor: '',
            //     marginColor: null,
            //     backgroundImages: [
            //         {
            //             url: 'https://assets.eetgroup.com/ow87vJrE0yDqyS9OzugPui3-joCcWb7Le5Tj1zAuOyg.jpg',
            //             width: 1440,
            //             height: 480
            //         },
            //         {
            //             url: 'https://assets.eetgroup.com/gEfvQfDN93Mb5ijuwev_w7s0VCjDTLy1BbjoywsACdg.jpg',
            //             width: 710,
            //             height: 474
            //         }
            //     ],
            //     imageLeft: null,
            //     imageRight: null,
            //     shim: false,
            //     shimColor: '',
            //     header: 'Remote controllers',
            //     headerColor: '#ffffff',
            //     subheader: 'Replace your broken or lost remote with universal remote controllers for Samsung and Sony TVs',
            //     subheaderColor: '#ffffff',
            //     caption: 'CoreParts',
            //     captionColor: '#ffffff',
            //     menuColor: null,
            //     topColor: null,
            //     subheaderFontSizeValue: 0,
            //     callToAction: {
            //         name: 'Order here',
            //         target: '',
            //         url: '/consumer-electronics/sound-vision/tv-accessories/remote-controls/c-25725763?ATTR_Brandname=CoreParts&lastFacet=ATTR_Brandname'
            //     },
            //     callToActionColor: '#ffffff',
            //     contentBackgroundColor: '#27aae1',
            //     makeContentBackgroundTransparent: false,
            //     takeoverTheme: null,
            //     contentWidthValue: 1,
            //     contentAligmentValue: 0,
            //     lineItemId: 'n9jwvwrkj8ntq2k2',
            //     creativeId: 'hq1pr8vp2cxb5zyb',
            //     adUnitId: '00000000000a30f7',
            //     layoutId: 'ydylnrst8k9kd0dc',
            //     vimeoVideoId: '',
            //     overlayVimeoVideoId: '',
            //     overlayVimeoCta: null
            // },
            // {
            //     renderedPixelUrl: 'https://delivery.adnuntius.com/b/uRvnEw53kBUmfvCW_ZdlM48gOuECPkV4DT42Pks6KPgAAAAQCtjQz9kbGWD4nuZy3q6HaHGLBt-sr6vGV0PUa7iKL4r1_xgFOAP_DJ7fwK27FHlLzlH9fQ9OqBy13R7vxT4tq_zw2QxPbI-9rowhcJRljAQA6VRkqZFbJWIVTdljEDl0WM8WU48WqRVnuLSXXbWUvL6bTEI_Vg6PMRfCUEt7kPaf90oHC-GEMrR4VfZucZGeTn0jpW3LZeS3zo0Z3fB1YFZG_dxe-OB-HMA3X8zadeGi7RORs7GsqXYCdNQyDbA3L4Tg97DTDaHphyeX6iaCoK6KrWq2WG8QAw.html',
            //     visiblePixelUrl: 'https://delivery.adnuntius.com/s?rt=uRvnEw53kBUmfvCW_ZdlM48gOuECPkV4DT42Pks6KPgAAAAQCtjQz9kbGWD4nuZy3q6HaHGLBt-sr6vGV0PUa7iKL4r1_xgFOAP_DJ7fwK27FHlLzlH9fQ9OqBy13R7vxT4tq_zw2QxPbI-9rowhcJRljAQA6VRkqZFbJWIVTdljEDl0WM8WU48WqRVnuLSXXbWUvL6bTEI_Vg6PMRfCUEt7kPaf90oHC-GEMrR4VfZucZGeTn0jpW3LZeS3zo0Z3fB1YFZG_dxe-OB-HMA3X8zadeGi7RORs7GsqXYCdNQyDbA3L4Tg97DTDaHphyeX6iaCoK6KrWq2WG8QAw',
            //     viewPixelUrl: 'https://delivery.adnuntius.com/v?rt=uRvnEw53kBUmfvCW_ZdlM48gOuECPkV4DT42Pks6KPgAAAAQCtjQz9kbGWD4nuZy3q6HaHGLBt-sr6vGV0PUa7iKL4r1_xgFOAP_DJ7fwK27FHlLzlH9fQ9OqBy13R7vxT4tq_zw2QxPbI-9rowhcJRljAQA6VRkqZFbJWIVTdljEDl0WM8WU48WqRVnuLSXXbWUvL6bTEI_Vg6PMRfCUEt7kPaf90oHC-GEMrR4VfZucZGeTn0jpW3LZeS3zo0Z3fB1YFZG_dxe-OB-HMA3X8zadeGi7RORs7GsqXYCdNQyDbA3L4Tg97DTDaHphyeX6iaCoK6KrWq2WG8QAw',
            //     clickPixelUrl: 'https://delivery.adnuntius.com/c/uRvnEw53kBUmfvCW_ZdlM48gOuECPkV4DT42Pks6KPgAAAAQCtjQz9kbGWD4nuZy3q6HaHGLBt-sr6vGV0PUa7iKL4r1_xgFOAP_DJ7fwK27FHlLzlH9fQ9OqBy13R7vxT4tq_zw2QxPbI-9rowhcJRljAQA6VRkqZFbJWIVTdljEDl0WM8WU48WqRVnuLSXXbWUvL6bTEI_Vg6PMRfCUEt7kPaf90oHC-GEMrR4VfZucZGeTn0jpW3LZeS3zo0Z3fB1YFZG_dxe-OB-HMA3X8zadeGi7RORs7GsqXYCdNQyDbA3L4Tg97DTDaHphyeX6iaCoK6KrWq2WG8QAw',
            //     backgroundColor: '',
            //     marginColor: null,
            //     backgroundImages: [
            //         {
            //             url: 'https://assets.eetgroup.com/lOQ8dS1zJ0ab4kTWqU0cYGy_MfegSJ0xk1HhMc3SP98.jpg',
            //             width: 1440,
            //             height: 480
            //         },
            //         {
            //             url: 'https://assets.eetgroup.com/7U_KE0JQt-JQYtEwY0zOYhoTr6aFV8rhyaHNVnUawM4.jpg',
            //             width: 710,
            //             height: 474
            //         }
            //     ],
            //     imageLeft: null,
            //     imageRight: null,
            //     shim: false,
            //     shimColor: '',
            //     header: 'Solar charging',
            //     headerColor: '#ffffff',
            //     subheader: 'Enjoy the great outdoors and charge your devices anywhere, at anytime with solar powerbanks and solar chargers.',
            //     subheaderColor: '#ffffff',
            //     caption: 'SANDBERG',
            //     captionColor: '#ffffff',
            //     menuColor: null,
            //     topColor: null,
            //     subheaderFontSizeValue: 1,
            //     callToAction: {
            //         name: 'Order here',
            //         target: '',
            //         url: '/campaigns/sandberg_solar_products'
            //     },
            //     callToActionColor: '#ffffff',
            //     contentBackgroundColor: '#3EBAEB',
            //     makeContentBackgroundTransparent: true,
            //     takeoverTheme: null,
            //     contentWidthValue: 1,
            //     contentAligmentValue: 0,
            //     lineItemId: 'bqlb2kkc0wr8rv9j',
            //     creativeId: 'pr6vdm38qvwlchrd',
            //     adUnitId: '00000000000a30f8',
            //     layoutId: 'ydylnrst8k9kd0dc',
            //     vimeoVideoId: '',
            //     overlayVimeoVideoId: '',
            //     overlayVimeoCta: null
            // },
            // {
            //     renderedPixelUrl: 'https://delivery.adnuntius.com/b/fPoUdjSO-OejFhPaNga4Snr-5yDXodA9iBh-fWEqUvUAAAAQCtjQz9kbGWD4nuZy3q6HaHGLBt-sr6vGV0PUa7iKL4r1_xgFOAP_DJ7fwK27FHlLzlH9fQ9OqBy1oUjzxTg1n-3w2QxPbI-9r4whcJRdwA0j6SRn67UjZj9tjb4WFW5wWZVACt9P_Eky5OnMXe_OsOjISR05VlzQMkXCXBwnwvCY8xgHWOPYNLspBaQ9JJPPHCp-8zOdNrXgyI5sioYlMAga9dRY4u5uTN4lW3_pTN9WsiSC4bKv-nBUJdg0ArZieILk97CGWvXogXKW63zUq6SJFpAve4ka1pai.html',
            //     visiblePixelUrl: 'https://delivery.adnuntius.com/s?rt=fPoUdjSO-OejFhPaNga4Snr-5yDXodA9iBh-fWEqUvUAAAAQCtjQz9kbGWD4nuZy3q6HaHGLBt-sr6vGV0PUa7iKL4r1_xgFOAP_DJ7fwK27FHlLzlH9fQ9OqBy1oUjzxTg1n-3w2QxPbI-9r4whcJRdwA0j6SRn67UjZj9tjb4WFW5wWZVACt9P_Eky5OnMXe_OsOjISR05VlzQMkXCXBwnwvCY8xgHWOPYNLspBaQ9JJPPHCp-8zOdNrXgyI5sioYlMAga9dRY4u5uTN4lW3_pTN9WsiSC4bKv-nBUJdg0ArZieILk97CGWvXogXKW63zUq6SJFpAve4ka1pai',
            //     viewPixelUrl: 'https://delivery.adnuntius.com/v?rt=fPoUdjSO-OejFhPaNga4Snr-5yDXodA9iBh-fWEqUvUAAAAQCtjQz9kbGWD4nuZy3q6HaHGLBt-sr6vGV0PUa7iKL4r1_xgFOAP_DJ7fwK27FHlLzlH9fQ9OqBy1oUjzxTg1n-3w2QxPbI-9r4whcJRdwA0j6SRn67UjZj9tjb4WFW5wWZVACt9P_Eky5OnMXe_OsOjISR05VlzQMkXCXBwnwvCY8xgHWOPYNLspBaQ9JJPPHCp-8zOdNrXgyI5sioYlMAga9dRY4u5uTN4lW3_pTN9WsiSC4bKv-nBUJdg0ArZieILk97CGWvXogXKW63zUq6SJFpAve4ka1pai',
            //     clickPixelUrl: 'https://delivery.adnuntius.com/c/fPoUdjSO-OejFhPaNga4Snr-5yDXodA9iBh-fWEqUvUAAAAQCtjQz9kbGWD4nuZy3q6HaHGLBt-sr6vGV0PUa7iKL4r1_xgFOAP_DJ7fwK27FHlLzlH9fQ9OqBy1oUjzxTg1n-3w2QxPbI-9r4whcJRdwA0j6SRn67UjZj9tjb4WFW5wWZVACt9P_Eky5OnMXe_OsOjISR05VlzQMkXCXBwnwvCY8xgHWOPYNLspBaQ9JJPPHCp-8zOdNrXgyI5sioYlMAga9dRY4u5uTN4lW3_pTN9WsiSC4bKv-nBUJdg0ArZieILk97CGWvXogXKW63zUq6SJFpAve4ka1pai',
            //     backgroundColor: '',
            //     marginColor: null,
            //     backgroundImages: [
            //         {
            //             url: 'https://assets.eetgroup.com/O5hkEcXaIONDDHeWVq_7Zia-M-jhFqnY33hIpsq48js.jpg',
            //             width: 1440,
            //             height: 480
            //         },
            //         {
            //             url: 'https://assets.eetgroup.com/7mxTqviCrIh0uOpnAaVXB36y1qfCa2dF0GTe_wFKf8Y.jpg',
            //             width: 710,
            //             height: 474
            //         }
            //     ],
            //     imageLeft: null,
            //     imageRight: null,
            //     shim: false,
            //     shimColor: '',
            //     header: 'New iPhone out now',
            //     headerColor: '#ffffff',
            //     subheader: 'Stock up on accessories for the NEW iPhone 14 series',
            //     subheaderColor: '#ffffff',
            //     caption: 'eSTUFF',
            //     captionColor: '#ffffff',
            //     menuColor: null,
            //     topColor: null,
            //     subheaderFontSizeValue: 1,
            //     callToAction: {
            //         name: 'Order here',
            //         target: '',
            //         url: '/campaigns/iphone_14_assortment'
            //     },
            //     callToActionColor: '#ffffff',
            //     contentBackgroundColor: '#00a19b',
            //     makeContentBackgroundTransparent: true,
            //     takeoverTheme: null,
            //     contentWidthValue: 1,
            //     contentAligmentValue: 0,
            //     lineItemId: 'dct695smy0qst5zm',
            //     creativeId: 'grckvcw5hbzxb1m5',
            //     adUnitId: '00000000000cda57',
            //     layoutId: 'ydylnrst8k9kd0dc',
            //     vimeoVideoId: '',
            //     overlayVimeoVideoId: '',
            //     overlayVimeoCta: null
            // }
        ];
    }

    mounted() {
        this.loadAllIcons();
        this.verifyLabels();
    }

    loadAllIcons() {
        const iconsInPath = require.context('@/project/icons', false, /^(?!.*\.ts).*/);
        this.allIcons = iconsInPath.keys().filter(filename => filename !== './index' && filename.match(/[a-z]/)).map(filename => filename.replace('./', ''));
    }

    verifyLabels(): null | string {
        return dictionaryService.exists('Product.Relations.ProductRelatedProductExact.BodyText') ? dictionaryService.get('Product.Relations.ProductRelatedProductExact.BodyText') : null;
    }

    private linkClick() {
        // eslint-disable-next-line
        console.log('Hallo');
    }

    private changed() {
        console.log('changed');
    }

    private fileChanged(filesEvent) {
        console.log('files changes', filesEvent);
    }

    private submit() {
        console.log('submit');
    }

    private download() {
        window.alert('download');
    }

    @Watch('model', { deep: true })
    onModelChange(newModel, oldModel) {
        console.log('modelChange', newModel, oldModel);
    }

    get rulesForStreet(): string {
        return (this.model?.country ? validationRuleAddressField(this.model.country) : []).join('|');
    }

    private triggerErrorToast() {
        const clientMessages: ClientMessageWithError = {
            errorId: 'xyz' + Math.random(),
            messages: [
                {
                    errorId: 'xyz1',
                    message: 'Information.BecomeAReseller.InvoiceAddress',
                    messageType: ClientMessageType.Info
                },
                {
                    errorId: 'xyz2',
                    message: 'Not a label',
                    messageType: ClientMessageType.Warning
                },
                {
                    errorId: 'xyz3',
                    message: 'This is an error',
                    messageType: ClientMessageType.Error
                }
            ]
        };
        bus.emit(GeneralErrorEventKey, clientMessages);
    }

    // Custom links in checkbox
    private get links(): TranslationLink[] {
        return [
            {
                name: 'MyAccount.Settings.TermsPage',
                action: () => {
                    contentPageOverlayService.show(serverContextService.settings.termsPage);
                }
            },
            {
                name: 'MyAccount.Settings.DataProcessingAgreementPage',
                action: () => {
                    contentPageOverlayService.show(serverContextService.settings.dataProcessingAgreementPage);
                }
            }];
    }
}
